import { apiRoutes } from 'app/globals';
import * as api from 'app/lib/ajax';


export const getConfig = () => (
    api.get(apiRoutes.GET_CONFIG)
);

export const getStats = () =>  (
    api.get(apiRoutes.GET_STATS)
);